import { render, staticRenderFns } from "./VisaDetail.vue?vue&type=template&id=283ec475&"
import script from "./VisaDetail.vue?vue&type=script&lang=js&"
export * from "./VisaDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports